import axios from "axios"
import { config } from './apiUrl';

export  const createSubscription = (data) =>{
  return axios.post(`${config.getRegistration}?p=register`,data)}